import React, { useEffect, useMemo, useState } from 'react';
import { FileText, MapPin, BarChart3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import TrialCreation from '../trial-creation/TrialCreation';
import ViewAssignment from '../trial-creation/ViewAssignment';
import TrialView from '../trial-creation/TrialView';
import TrialCentreView from '../trial-creation/TrialCentreView';
import TrialCentreLocationView from '../trial-creation/TrialCentreLocationView';
import DataEntry from './DataEntry';

const OfficerWorkspace = () => {
  const [activeTab, setActiveTab] = useState('trial'); // 'trial' | 'centre' | 'plot'
  const navigate = useNavigate();
  const { user } = useAuth();

  const assignActiveTab = (tab) => {
    navigate({ pathname: '/officer'}, { replace: true });
    setActiveTab(tab);
  }

  const defaultCentreTrialId = useMemo(() => {
    try {
      const rawT = window.localStorage.getItem('trials');
      const rawA = window.localStorage.getItem('trialAssignments');
      const trials = rawT ? JSON.parse(rawT) : [];
      const assigns = rawA ? JSON.parse(rawA) : [];
      const lowerName = (user?.name || '').toLowerCase();

      // Prefer trials where officer is centre incharge; then assigned officer; then trial incharge
      const idsByPriority = [
        new Set(assigns.filter(a => (a.centreIncharge || '').toLowerCase() === lowerName).map(a => a.trialId)),
        new Set(assigns.filter(a => (a.assignedOfficer || '').toLowerCase() === lowerName).map(a => a.trialId)),
        new Set(trials.filter(t => (t.trialInchargeOfficer || '').toLowerCase() === lowerName).map(t => t.id))
      ];
      for (const idSet of idsByPriority) {
        if (idSet.size > 0) return Array.from(idSet.values())[0];
      }
      return trials[0]?.id || null;
    } catch { return null; }
  }, [user]);

  useEffect(() => {
    // if (activeTab === 'centre' && defaultCentreTrialId) {
    //   // Ensure we stay on /officer and only change query string
    //   navigate({ pathname: '/officer', search: `?view=detail&id=${defaultCentreTrialId}` }, { replace: true });
    // }
    // Do not reset the query string for other tabs; it breaks in-tab navigation
  }, [activeTab, defaultCentreTrialId, navigate]);

  return (
    <div className="space-y-4">
      <div className="bg-white border border-gray-200 rounded-lg p-3">
        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={() => assignActiveTab('trial')}
            className={`inline-flex items-center px-3 py-2 rounded-lg text-sm border ${
              activeTab === 'trial'
                ? 'bg-primary-600 text-white border-primary-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            <FileText className="w-4 h-4 mr-2" />
            Trial Management
          </button>
          <button
            onClick={() => assignActiveTab('centre')}
            className={`inline-flex items-center px-3 py-2 rounded-lg text-sm border ${
              activeTab === 'centre'
                ? 'bg-primary-600 text-white border-primary-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            <MapPin className="w-4 h-4 mr-2" />
            Centre Management
          </button>
          <button
            onClick={() => assignActiveTab('plot')}
            className={`inline-flex items-center px-3 py-2 rounded-lg text-sm border ${
              activeTab === 'plot'
                ? 'bg-primary-600 text-white border-primary-600'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            <BarChart3 className="w-4 h-4 mr-2" />
            Location Management
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'trial' && (
        <div className="space-y-4">
          <TrialView officerSource="trial" />
        </div>
      )}
      {activeTab === 'centre' && (
        <div className="space-y-4">
          <TrialCentreView officerSource="centre" />
        </div>
      )}
      {activeTab === 'plot' && (
        <div className="space-y-4">
          <TrialCentreLocationView officerSource="plot" />
        </div>
      )}
    </div>
  );
};

export default OfficerWorkspace;

